import Vue from 'vue';
import VueAMap from 'vue-amap';
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
  key: 'fad77c9ed3332aae8bcd54cd035aa38b',
  plugin: ['AMap.Geolocation', 'AMap.Marker', 'AMap.ToolBar', 'AMap.Circle', 'AMap.PolyLine'],
  uiVersion: '1.0',
  v: '1.4.8'
});
